export default "__VITE_ASSET__BPAaJHgc__"